
import {
	computed,
	defineComponent,
	inject,
	onBeforeMount,
	reactive,
	ref,
} from 'vue';
import Button from '@/components/ui-elements/form/Button.vue';
import Checkbox from '@/components/ui-elements/form/Checkbox.vue';
import DatePicker from '@/components/ui-elements/form/DatePicker.vue';
import {
	ExpenseFormContext,
	ExpenseFormContextType,
} from '@/components/modals/ExpenseFormProvider';
import Form from '@/components/ui-elements/form/Form';
import Input from '@/components/ui-elements/form/Input.vue';
import Select from '@/components/ui-elements/form/Select.vue';
import Textarea from '@/components/ui-elements/form/Textarea.vue';
import { useUserStore, useTypesStore } from '@/store';
import { getPaidDate } from '@/utils/expense-form';

export default defineComponent({
	components: {
		Button,
		Checkbox,
		DatePicker,
		Form,
		Input,
		Select,
		Textarea,
	},
	setup(props, { emit }) {
		const ExpenseContext = inject<ExpenseFormContextType>(
			ExpenseFormContext,
			{} as ExpenseFormContextType
		);
		const userStore = useUserStore();
		const typeStore = useTypesStore();

		const form = reactive({
			amount: {
				rules: ['required', 'float:2'],
				value: '0.00',
			},
			balance: {
				rules: ['required', 'float:2'],
				value: '0.00',
			},
			confirmation: {
				rules: [],
				value: '',
			},
			not_track_amount: {
				rules: [],
				value: false,
			},
			due_date: {
				rules: [],
				value: '1',
			},
			mileage: {
				rules: [],
				value: '',
			},
			notes: {
				rules: [],
				value: '',
			},
			paid_date: {
				rules: [],
				value: '',
			},
			type: {
				rules: ['required', 'gt:0'],
				value: 0,
			},
			vehicle: {
				rules: ['required', 'gt:0'],
				value: 0,
			},
		});
		const valid = ref(false);
		const vehicles = computed(() =>
			userStore.vehicleList.filter(vehicle => vehicle.active)
		);

		onBeforeMount(() => {
			form.paid_date.value = ExpenseContext.budgetCycle.value;

			if (Object.keys(ExpenseContext.data).length) {
				form.amount.value = ExpenseContext.data.amount;
				form.balance.value = ExpenseContext.data.balance || '';
				form.confirmation.value =
					ExpenseContext.data.confirmation || '';
				form.not_track_amount.value =
					!!ExpenseContext.data.not_track_amount || false;
				form.due_date.value = ExpenseContext.data.due_date || '';
				form.vehicle.value = ExpenseContext.data.user_vehicle_id || 0;
				form.mileage.value = ExpenseContext.data.mileage || '';
				form.notes.value = ExpenseContext.data.notes || '';
				form.paid_date.value = getPaidDate(ExpenseContext);
				form.type.value = ExpenseContext.getTypeId();
			}
		});

		const typeName = computed(() =>
			typeStore.getSlugById('vehicles', form.type.value)
		);

		const closeModal = (submit: boolean) => {
			let data: Record<string, string> = {};

			if (submit && ExpenseContext) {
				data = ExpenseContext.extractFormValues(form);
			}

			ExpenseContext?.closeModal(data);
		};

		const updateVehicleType = (e: number) => {
			form.type.value = e;
			emit('update-category');
		};

		return {
			closeModal,
			dates: ExpenseContext?.dates ?? [],
			editMode: ExpenseContext.editMode,
			form,
			typeName,
			types: ExpenseContext.typeList,
			updateVehicleType,
			valid,
			vehicles,
		};
	},
});
